import { Drawer } from "antd";
import Close from "../../../../assets/images/close-x.svg";

const AdditionalChargesDrawer = ({
  additionalCharges,
  setAdditionalCharges,
  tempSaleTypeData,
  getChargeLabel,
  cart,
}) => {
  return (
    <Drawer
      title={
        <div style={{ display: "flex", fontSize: "1vw", alignItems: "center" }}>
          <p style={{ fontSize: "1.5em", fontWeight: 600, color: "#0F0718", flex: 1 }}>Additional Charges</p>
          <img
            src={Close} // Ensure Close is imported or replace with a valid image path
            onClick={() => {
              //resetToInitialState();
              setAdditionalCharges(false);
            }}
            style={{ float: "right", cursor: "pointer", marginTop: "-3vh", marginRight: "-0.5vw", width: "1.5vw" }}
          />
        </div>
      }
      closable={false}
      maskClosable={false}
      placement="right"
      closeIcon={null}
      open={additionalCharges}
      width={400} // Increased width for a cleaner look
      onClose={() => {
        //resetToInitialState();
        setAdditionalCharges(false);
      }}
    >
      {/* <div style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
        <span style={{ fontSize: "15px", fontWeight: 550 }}>% Service Charges</span>
        <Switch checked={serviceChargeEnabled} onChange={(checked) => setServiceChargeEnabled(checked)} style={{ marginRight: "10px" }} />
      </div>
      <div style={{ marginBottom: "20px", display: "flex", alignItems: "center" }}>
        <Select
          value={serviceChargePercentage}
          onChange={(value) => setServiceChargePercentage(value)}
          disabled={!serviceChargeEnabled}
          style={{ width: "80px", marginRight: "10px" }}
        >
          <Option value={5}>5%</Option>
          <Option value={7}>7%</Option>
          <Option value={10}>10%</Option>
          <Option value={12}>12%</Option>
          <Option value={15}>15%</Option>
        </Select>
      </div> */}

      {/* <div style={{ marginBottom: "20px" }}>
        <p style={{ marginBottom: "8px", fontSize: "15px", fontWeight: 550 }}>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          Tip
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </p>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Select
            value={tipMode}
            onChange={(value) => {
              setTipMode(value); // Handle change for tip mode
              if (value === "Percentage") {
                setTipPercentage(0);
                setTipAmount(0);
              } else {
                setTipPercentage(0);
                setTipAmount(0);
              }
            }}
            style={{ width: 130, marginRight: "10px" }}
          >
            <Option value="Percentage">Percentage</Option>
            <Option value="Amount">Amount</Option>
          </Select>
          {tipMode === "Percentage" ? (
            <Select value={tipPercentage} onChange={(value) => setTipPercentage(value)} style={{ width: "80px", marginRight: "10px" }}>
              <Option value={0}>0%</Option>
              <Option value={5}>5%</Option>
              <Option value={7}>7%</Option>
              <Option value={10}>10%</Option>
              <Option value={12}>12%</Option>
              <Option value={15}>15%</Option>
            </Select>
          ) : (
            <Input
              value={tipAmount}
              onChange={(e) => setTipAmount(parseFloat(e.target.value) || 0)}
              style={{ width: "100px", textAlign: "right" }}
              prefix={`${currenciesList[0].currSymbol}`}
            />
          )}
        </div>
      </div> */}

      {/* <div style={{ marginBottom: "20px" }}>
        <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
          <span style={{ marginRight: "8px" }}>
            <CarOutlined />
          </span>{" "}
          Delivery Charges
        </p>
        <Input
          value={deliveryCharge}
          onChange={(e) => setDeliveryCharge(parseFloat(e.target.value) || 0)}
          style={{ width: "100px", textAlign: "right" }}
          prefix={`${currenciesList[0].currSymbol}`}
        />
      </div> */}
      {/*
      <div style={{ marginBottom: "20px" }}>
        <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
          <span style={{ marginRight: "8px" }}>
            <GiftOutlined />
          </span>{" "}
          Packing Charges
        </p>
        <Input
          value={packingCharge}
          onChange={(e) => setPackingCharge(parseFloat(e.target.value) || 0)}
          style={{ width: "100px", textAlign: "right" }}
          prefix={`${currenciesList[0].currSymbol}`}
        />
      </div> */}

      {/* <div style={{ marginBottom: "20px" }}>
        <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
          <span style={{ marginRight: "8px" }}>
            <ReloadOutlined />
          </span>{" "}
          Rounding
        </p>
        <Select value={roundingOption} onChange={(value) => setRoundingOption(value)} style={{ width: "150px" }}>
          <Option value="No Rounding">No Rounding</Option>
          <Option value="Round Up">Round Up</Option>
          <Option value="Round Down">Round Down</Option>
        </Select>
      </div> */}
      <div style={{ height: "calc(100% - 100px)", overflowY: "auto", paddingRight: 8 }}>
        {tempSaleTypeData?.map((charge) => (
          <div key={charge.chargeType} style={{ padding: "10px 0", borderBottom: "1px solid #e8e8e8" }}>
            <span style={{ fontSize: "14px", fontWeight: 600 }}>
              {charge.chargeType === "TCS" ? `TCS - ${(cart?.tcs ?? 0).toFixed(2)}` : getChargeLabel(charge, cart)}
            </span>
          </div>
        ))}
      </div>
      {/* <div
    style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      padding: "12px",
      display: "flex",
      justifyContent: "flex-end",
      background: "#fff",
      borderTop: "1px solid #e8e8e8"
    }}
  >
    <Button
      style={{
        backgroundColor: "#fff",
        color: "#2F3856",
        height: "40px",
        width: "100px",
        borderRadius: "5px",
        marginRight: "10px",
      }}
      onClick={() => setAdditionalCharges(false)}
    >
      Cancel
    </Button>

    <Button
      style={{
        backgroundColor: "#2F3856",
        color: "#fff",
        height: "40px",
        width: "140px",
        borderRadius: "5px",
        textAlign: "center",
      }}
      onClick={handleApplyCharges}
    >
      Apply Charges
    </Button>
  </div> */}
    </Drawer>
  );
};

export default AdditionalChargesDrawer;
